/**
 * Job seeker profile helpers — normalize education + experience entries
 * since the DB stores slightly different field names than older UI code expected.
 */

export const eduDegree = (e = {}) => e.degree || e.qualification || 'N/A';
export const eduInstitution = (e = {}) => e.institution || e.institution_name || e.university || 'N/A';
export const eduSpecialization = (e = {}) => e.specialization || e.course || '';
export const eduYear = (e = {}) => e.year_of_passing || e.to_year || e.year || 'N/A';
export const eduPercentage = (e = {}) => e.percentage || e.marks || null;
export const eduCourseType = (e = {}) => e.course_type || '';

export const expDesignation = (e = {}) => e.designation || e.job_title || e.role || 'N/A';
export const expCompany = (e = {}) => e.company || e.company_name || e.organization || 'N/A';
export const expIndustry = (e = {}) => e.industry || e.industry_type || '';
export const expEmploymentType = (e = {}) => e.employment_type || '';

const _monthName = (m) => {
  if (!m) return '';
  const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  const idx = parseInt(m, 10);
  return idx >= 1 && idx <= 12 ? months[idx - 1] : '';
};

export const expFromDate = (e = {}) => {
  if (e.from_date) return e.from_date;
  const m = _monthName(e.from_month);
  const y = e.from_year || '';
  return [m, y].filter(Boolean).join(' ') || '';
};

export const expToDate = (e = {}) => {
  if (e.to_date) return e.to_date;
  const m = _monthName(e.to_month);
  const y = e.to_year || '';
  const out = [m, y].filter(Boolean).join(' ');
  return out || 'Present';
};

export const expYears = (e = {}) => {
  if (e.years || e.years === 0) return e.years;
  const fy = parseInt(e.from_year, 10);
  const ty = parseInt(e.to_year, 10);
  if (!fy) return 0;
  const fm = parseInt(e.from_month || 1, 10);
  const tm = parseInt(e.to_month || (ty ? 12 : new Date().getMonth() + 1), 10);
  const toYear = ty || new Date().getFullYear();
  const months = (toYear - fy) * 12 + (tm - fm);
  return Math.max(0, Math.round((months / 12) * 10) / 10);
};
